export default __webpack_public_path__ + "static/media/mzo.b0c79042.png";